import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import { Collapse } from 'react-collapse';
import ContactPerson from '../contactPerson/ContactPerson';
import HomeTel from '../homeTel/HomeTel';
import Address from '../address/Address';
import OfficeTel from '../officeTel/OfficeTel';
import ProposerType from '../proposerType/ProposerType';
import Mobile from '../mobile/Mobile';
import PostalCode from '../postalCode/PostalCode';
import Fax from '../fax/Fax';
import Country from '../country/Country';
import Email from '../email/Email';

class CustomerContactInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">
          <a style={{ cursor: 'pointer' }} onClick={() => this.setState({ open: !this.state.open })}>
            {this.state.open ? 'Customer Contact Information ▲ ' : 'Customer Contact Information ▼'}
          </a>
        </h3>
        <Collapse isOpened={this.state.open}>
          <FormGroup controlId="contactPersonHomeTel">
            <Col sm={6}>
              <ContactPerson
                contactPerson={this.props.custContactInfo.contactPerson}
                handleChangeContactPerson={this.props.handleChangeCustContactInfo}
              />
            </Col>
            <Col sm={6}>
              <HomeTel
                homeTel={this.props.custContactInfo.homeTel}
                handleChangeHomeTel={this.props.handleChangeCustContactInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="proposerType">
            <Col sm={6}>
              <ProposerType
                proposerType={this.props.custContactInfo.proposerType}
                handleChangeProposerType={this.props.handleChangeCustContactInfo}
                proposerTypeId="cusProposerType"
              />
            </Col>
            <Col sm={6}>
              <OfficeTel
                officeTel={this.props.custContactInfo.officeTel}
                handleChangeOfficeTel={this.props.handleChangeCustContactInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="addressOfficeTel">
            <Col sm={6}>
              <Address
                address={this.props.custContactInfo.address}
                handleChangeAddress={this.props.handleChangeCustContactInfo}
              />
            </Col>
            <Col sm={6}>
              <Mobile
                mobile={this.props.custContactInfo.mobile}
                handleChangeMobile={this.props.handleChangeCustContactInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="postalCodeFax">
            <Col sm={6}>
              <PostalCode
                postalCode={this.props.custContactInfo.postalCode}
                handleChangePostalCode={this.props.handleChangeCustContactInfo}
              />
            </Col>
            <Col sm={6}>
              <Fax
                fax={this.props.custContactInfo.fax}
                handleChangeFax={this.props.handleChangeCustContactInfo}
              />
            </Col>
          </FormGroup>
          <FormGroup controlId="postalCodeFax">
            <Col sm={6}>
              <Country
                country={this.props.custContactInfo.country}
                handleChangeCountry={this.props.handleChangeCustContactInfo}
              />
            </Col>
            <Col sm={6}>
              <Email
                email={this.props.custContactInfo.email}
                handleChangeEmail={this.props.handleChangeCustContactInfo}
              />
            </Col>
          </FormGroup>
        </Collapse>
      </div>
    )
  }
}

CustomerContactInfo.propTypes = {
  custContactInfo: PropTypes.object,
  handleChangeCustContactInfo: PropTypes.func
};

export default CustomerContactInfo;



// WEBPACK FOOTER //
// ./src/app/components/customerContactInfo/CustomerContactInfo.js